import { useState } from 'react'
import { CDNImage } from '~/components/ui/CDNImage'
import ConsultModal from './ConsultModal'
import Link from 'next/link'
import classNames from 'classnames'
import useScrollTop from '~/hooks/useScrollTop'

function MirrorHeader() {
  const [visible, setVisible] = useState(false)
  const scrollTop = useScrollTop()
  const needFixed = scrollTop > 48

  return (
    <header
      className={classNames(
        'top-0 z-[1001] w-full px-6 h-[64px] flex items-center justify-between',
        `${
          needFixed
            ? 'fixed bg-white transition duration-100 ease-linear'
            : 'fixed'
        }`
      )}
      style={{
        boxShadow: needFixed
          ? ' 0px 20px 30px 0px rgba(0, 0, 0, 0.16)'
          : 'none',
      }}
    >
      <CDNImage
        className="h-[48px]"
        src={
          needFixed
            ? '/images/mirror/mirror-logo-black.svg'
            : '/images/mirror/mirror-logo.svg'
        }
      />

      <div className="flex items-center gap-12">
        <div className="flex items-center">
          <Link
            href={
              'https://apifox.com/apidoc/shared-3d887fd4-759a-4884-83b6-644b66640358'
            }
            target="_blank"
            className={classNames(
              'bg-white bg-opacity-[0.16] rounded-full text-sm py-1.5 px-6 font-semibold text-white mr-6 text-center cursor-pointer border-2 border-[#C8C9D1] backdrop-blur-[4px] hover:text-neutral-900',
              {
                ['backdrop-blur-none border-none bg-neutral-400 text-neutral-100 hover:text-neutral-100']:
                  needFixed,
              }
            )}
            style={{
              boxShadow: 'none',
            }}
          >
            查看文档
          </Link>

          <div
            className="rounded-full text-sm py-2 px-6 font-semibold text-white hover:text-white cursor-pointer"
            style={{
              background:
                'linear-gradient(321deg, #6964DE -10.33%, #FCA6E9 100%)',
            }}
            onClick={() => setVisible(true)}
          >
            立即咨询
          </div>
        </div>
      </div>
      <ConsultModal visible={visible} setVisible={setVisible} />
    </header>
  )
}

export default MirrorHeader
